import { NarrativeSource } from '@/server/services/GoogleBigQuery/BigQueryNarrativesClient.types';
import {
  FavouriteNode,
  NarrativeFile,
  NarrativeNodesRelation,
  NarrativeRecordRaw,
  NarrativeRelationMessagesRequestParams,
  NarrativeRelationMessagesResponse,
  NodeNarrativesRequestParams,
  NodeNarrativesResponse,
  NodeRelationsRequestParams,
} from '@/server/services/Neo4jClient/Neo4jClient.types';
import { ROUTE, axiosInstance } from './axiosInstance';

import type { NetworkNodeStyleMap, NetworkRelationStyleMap } from '@/app/api/narratives/node-customizations/types';

export const narratives = {
  getRecords: async () => {
    const { data } = await axiosInstance.get<NarrativeRecordRaw[]>(ROUTE.NARRATIVES.RECORDS);
    return data;
  },

  /**
   * loadDate in format "2025-06" (2025 Jun)
   */
  getRelations: async (params: NodeRelationsRequestParams) => {
    const { data } = await axiosInstance.get<NarrativeNodesRelation>(ROUTE.NARRATIVES.RELATIONS, {
      params: { ...params },
    });
    return data;
  },

  getRelationMessages: async (params: NarrativeRelationMessagesRequestParams) => {
    const { data } = await axiosInstance.get<NarrativeRelationMessagesResponse>(ROUTE.NARRATIVES.RELATION_MESSAGES, {
      params: { ...params },
    });
    return data;
  },

  getFiles: async () => {
    const { data } = await axiosInstance.get<NarrativeFile[]>(ROUTE.NARRATIVES.FILES);
    return data;
  },

  getSourcesDetails: async (params: { Links: string[] }) => {
    const { data } = await axiosInstance.post<NarrativeSource[]>(ROUTE.NARRATIVES.SOURCE, params);
    return data;
  },

  getNodesNarratives: async (params: NodeNarrativesRequestParams) => {
    const { data } = await axiosInstance.post<NodeNarrativesResponse>(ROUTE.NARRATIVES.NODE_NARRATIVES, params);
    return data;
  },

  getFavouriteNodes: async (params?: { sourceId?: string; userId?: string; topic?: NarrativeFile['topic_name'] }) => {
    const { data } = await axiosInstance.get<FavouriteNode[]>(ROUTE.NARRATIVES.FAVOURITE_NODES, {
      params: { ...params },
    });
    return data;
  },

  updateFavouriteStatus: async (params: {
    sourceId: FavouriteNode['NodeId'];
    userId: FavouriteNode['UserId'];
    isFavourite: boolean;
  }) => {
    const { data } = await axiosInstance.post<FavouriteNode | null>(ROUTE.NARRATIVES.FAVOURITE_NODES, params);
    return data;
  },

  getGraphCustomizations: async () => {
    const { data } = await axiosInstance.get<{
      nodeCustomizations: NetworkNodeStyleMap;
      relationCustomizations: NetworkRelationStyleMap;
    }>(ROUTE.NARRATIVES.NODE_CUSTOMIZATIONS);

    return data;
  },
};
